var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseCasesBgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1880,
    height: 691,
    viewBox: "0 0 1880 691",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_34633)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1880,
    height: 691,
    rx: 20,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_92_34633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-256 1323.5C-197.167 1151.17 201.1 785.9 419.5 715.5C692.5 627.5 1062.5 607 1359 519C1752.5 402.211 2001.83 119.667 2175 -36",
    stroke: "#6F75FF",
    strokeOpacity: 0.6,
    strokeWidth: 115
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_92_34633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-256 1018.5C-197.167 846.167 201.1 480.9 419.5 410.5C692.5 322.5 1062.5 302 1359 214C1752.5 97.2108 2001.83 -185.333 2175 -341",
    stroke: "#FF5C00",
    strokeOpacity: 0.5,
    strokeWidth: 115
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_92_34633",
    x: -610.417,
    y: -378.762,
    width: 3123.86,
    height: 2020.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_92_34633"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_92_34633",
    x: -610.417,
    y: -683.762,
    width: 3123.86,
    height: 2020.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_92_34633"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_34633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1880,
    height: 691,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCasesBgImage);
export default __webpack_public_path__ + "static/media/UseCasesBgImage.9ef61a14b587572c96657b32df189b79.svg";
export { ForwardRef as ReactComponent };